import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state:{//要设置的全局访问的全局对象
        list:[],//初始的list属性
        currentItem:{},
        currentScene:'',
        aside: false, //默认隐藏侧边栏
        audio:false,
    },
    getters: {//实时监听state值的变化(最新)
        getlist(state) {
            return state.list
        }
    },
    mutations: {
        getList(state,data) {
            state.list = data;
        },
        getCurrentItem(state,data) {
            state.currentItem = data;
        },
        getcurrentScene(state,data) {
            state.currentScene = data;
        },
        changeAside(state,data) {
            state.aside = data
        },
        changeAudio(state,data) {
            state.audio = data
        }
    }

})